import http from "./http.js"
export default {
  http,
  foot(data) {  //底部
    return http.get('index/indexmenu', data);
  },
  indexuser(data) { //主页用户信息
    return http.get('index/indexuser', data);
  },
  uservisit(data) { //访问记录接口
    return http.post('index/uservisit', data);
  },
  booking(data) { //访问记录接口
    return http.post('booking/booking', data);
  },
  center(data) { //访问个人中心记录接口
    return http.get('broker/index', data);
  },
  bank(data) { //访问银行记录接口
    return http.get('broker/bank', data);
  },
  recommend(data) { //访问推荐客户记录接口
    return http.post('broker/recom', data);
  },
  myCustom(data) { //访问我的客户记录接口
    return http.get('broker/customer', data);
  },
  customDetail(data) { //访问客户详情记录接口
    return http.get('broker/customer_detail', data);
  },
  cmsDetail(data) { //访问佣金明细记录接口
    return http.get('broker/recode', data);
  },
  brokerDetail(data) { //获取客户素材详细信息
    return http.get('broker/detail', data);
  },
  getLogin(data) { //获取个人信息
    return http.get('broker/login', data);
  },
  postLogins(data) { //修改个人信息
    return http.post('broker/changeinfo', data);
  },
  editBrokerDetail(data) { //编辑客户素材详细信息
    return http.post('broker/detail', data);
  },
  getTx(data) { //获取提现
    return http.get('broker/getrecode', data);
  },
  postTx(data) { //提交提现
    return http.post('broker/getrecode', data);
  },
  getBank(data){//获取银行卡信息
    return http.get('broker/bank',data)
  },
  postBank(data){//修改银行卡信息
    return http.post('broker/bank',data)
  },
  tousu(data){//投诉
    return http.post('broker/message',data)
  },
  content(data){//经纪人须知
    return http.post('broker/content',data)
  },
  wxConfig(data){
    return http.post('weixin/index',data,{nv1:true})
  },
  gwlist(data){
    return http.get('broker/gwlist',data)
  },
  doshare(data){
    return http.get('index/do_share',data)
  },
  callphone(data){
    return http.get('index/callphone',data,{pass:true})
  }

}



// WEBPACK FOOTER //
// ./src/assets/api.js